import { defineMessages } from "@/i18n";
import en from "./en";

export const imageFrameMessages = defineMessages("frames-image", en);
